// src/hooks/useInstagramFeed.ts
import { useEffect } from 'react';
import { useInstagramState } from '@/hooks/useInstagramState';
import { fetchInstagramPosts } from '@/utils/instagramApi';

export const useInstagramFeed = () => {
  const {
    posts,
    loading,
    error,
    lastUpdate,
    setLoading,
    updatePosts,
    setErrorMessage
  } = useInstagramState();

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const data = await fetchInstagramPosts();
      updatePosts(data.posts, data.lastUpdate);
    } catch (err) {
      setErrorMessage(err instanceof Error ? err : new Error('Erro ao carregar posts do Instagram'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { 
    posts, 
    loading, 
    error, 
    lastUpdate, 
    refresh: fetchPosts 
  };
};